import { PROGRESS_BAR_STATES } from 'common/constants/ProgressConstants';
import { setUploadedDocumentProgress } from 'common/store/reducer/commonReducer';

const { ALMOST_COMPLETE } = PROGRESS_BAR_STATES;
/**
 * @description to handle the progress of multi file upload
 */
export const multiFileUploadHandler = (
	progressEvent: any,
	index: number,
	updateprogress: any,
) => {
	const progress = Math.round(
		(progressEvent.loaded * ALMOST_COMPLETE) / progressEvent.total,
	);
	const updatedFileData = { index, progress };
	updateprogress(setUploadedDocumentProgress(updatedFileData));
};
